import { h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { ResultItemContext } from '../../../types';

const st0 = { fill: '#e4e4e4' };
const st1 = { fill: '#fff' };
const st2 = { fill: '#f6f6f6' };
const st3 = { fill: '#b2b2b2' };
const st4 = { fill: '#ccc' };

const getPlaceholderImage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" version="1.1" viewBox="0 0 156 104">
    <path d="M0 0h155.9v104H0z" style={st0} />
    <path
      d="m9 45.5 56.1-9.9c.8-.1 1.6.4 1.7 1.2l7.5 42.3c.1.8-.4 1.6-1.2 1.7L17 90.8c-.8.1-1.6-.4-1.7-1.2L7.7 47.2c-.1-.8.4-1.6 1.3-1.7z"
      style={st1}
    />
    <circle cx="36.8" cy="39.2" r="15.5" style={st1} transform="rotate(-10 36.8 39.2)" />
    <path
      id="uuid-9e1eac7b-a46f-4a74-816b-e7f6e83296de"
      d="M34.5 26.4a13 13 0 0 1 15 10.5A13 13 0 1 1 24 41.5a13 13 0 0 1 10.5-15.1z"
      style={st2}
    />
    <ellipse
      id="uuid-287beee7-ab5d-4859-bf07-f432080ff077"
      cx="30.7"
      cy="35.4"
      style={st3}
      rx="1"
      ry=".6"
      transform="rotate(-10 30.7 35.4)"
    />
    <path
      d="M43.5 33.6c0-.2-.2-.4-.5-.3l-3 .5 1.2-.2-1.5-1.1c-.2-.3-.5-.5-.9-.4l-2.5.4c-.3.1-.6.3-.7.7l-1 1.6 1.2-.2-3.9.7h-.2l-2 .3c-.3.1-.5.4-.5.7l1.5 8.6c.1.3.4.5.7.5l.8-.1 12.6-2.2c.2 0 .4-.2.3-.5l-1.6-9zm-7.4.9-.2-1c0-.3.2-.6.5-.7l2.5-.4c.3 0 .6.2.7.5l.2 1-3.7.6z"
      style={st4}
    />
    <path
      id="uuid-afb0b37a-c40a-4b91-a0e9-486793e9cdc2"
      d="M43 39.7c-.5.1-.9-.2-1-.7l-.2-.9c-.1-.5.2-.9.7-1s.9.2 1 .7l.2.9c0 .4-.3.9-.7 1z"
      style={st0}
    />
    <path
      id="uuid-7a729464-e57b-42da-b5bb-ba6b0836d3a7"
      d="M39.6 43.5c-2.3.4-4.4-1.1-4.8-3.4s1.1-4.4 3.4-4.8 4.4 1.1 4.8 3.4-1.1 4.4-3.4 4.8zm-1.3-7.2c-1.7.3-2.9 2-2.6 3.7s2 2.9 3.7 2.6c1.7-.3 2.9-2 2.6-3.7-.3-1.8-2-2.9-3.7-2.6z"
      style={st3}
    />
    <path
      id="uuid-9dd270bb-2c8e-4ae7-a260-f08d01205ee8"
      d="M40.5 37a2.9 2.9 0 0 0-4 .8 3 3 0 0 0 .7 3.9l3.3-4.7z"
      style={st1}
    />
    <path
      d="m90.4 33.2 56.1 9.9c.8.1 1.4.9 1.2 1.8l-7.6 43.3c-.1.8-.9 1.4-1.8 1.2l-56.1-9.9c-.8-.1-1.4-.9-1.2-1.8l7.6-43.3c.2-.8 1-1.3 1.8-1.2z"
      style={st1}
    />
    <circle cx="118.7" cy="36.8" r="15.5" style={st1} transform="rotate(-80 118.7 36.8)" />
    <path
      id="uuid-fc0a20f8-1192-469a-8eba-8cd16535cb56"
      d="M120.9 24a13 13 0 0 1 10.6 15.1c-1.2 7.1-8 11.8-15.1 10.5s-11.8-8-10.6-15.1 8-11.7 15.1-10.5z"
      style={st2}
    />
    <path
      id="uuid-55b5bf35-0547-49b5-98e3-ed80bc7ba5d3"
      d="M120.5 28.6a5.3 5.3 0 0 0-6.2 4.3c-.2 1.2.4 3.4.8 4.8l.4 1.9.2.7 5.2.9.5-.6 1-1.7c.9-1.2 2.2-3.1 2.4-4.3a5.2 5.2 0 0 0-4.3-6z"
      style={st4}
    />
    <path
      id="uuid-29a68461-5bea-4ead-aca4-eb7305fd9e69"
      d="M120.7 30.8v-.5l.3-.1c.8.2 2 .9 2.1 2.8.3 2.7-.9-.3-2.4-2.2z"
      style={st1}
    />
    <path
      id="uuid-0ebcf33b-a42f-4114-90a0-97f6fe369aa5"
      d="M118.2 41.7c.6-.9.9-2 .9-3.2 0-.7-.1-1.5-.5-2-.3-.4-1-.6-1.3-.1-.3.5 0 1.2.2 1.7.2.6.8 1 1.4 1 .7 0 1.3-.4 1.8-.9.4-.4 1-1 .6-1.6-.3-.6-1.1-.4-1.5 0-.6.6-.8 1.4-1.1 2.2-.1.3.3.5.4.2l.7-1.7c.2-.3.4-.5.7-.6.5-.1.5.4.3.7-.4.5-.9 1-1.5 1.2-.7.2-1.3-.1-1.6-.8l-.2-.7c0-.2 0-.4.2-.5.2-.1.4.1.5.2.3.5.4 1.3.4 1.8 0 1.1-.3 2.4-1.1 3.2"
      style={st1}
    />
    <path
      id="uuid-8325aad2-a23e-44b6-934a-b022bb136322"
      d="m116.1 42.8 3.7.7c.2-.2.7-1.6.6-1.8l-4.4-.8.1 1.9z"
      style={st3}
    />
    <path
      id="uuid-a5b0ab72-9b7d-4422-8cc8-264f4bcff99c"
      d="M116.5 43.3c0 .7.5 1.2 1.1 1.3.7.1 1.3-.2 1.6-.9l-2.7-.4z"
      style={st4}
    />
    <path
      id="uuid-d9168ff6-a636-43d4-aaf7-93eee962ea92"
      d="M115.7 31.5H99l.1-1c0-11.6-9.4-21-21.1-21s-21.1 9.4-21.1 21v1H39.7a2 2 0 0 0-2 2v58.8c0 1.1.9 2 2 2h76a2 2 0 0 0 2-2V33.5a2 2 0 0 0-2-2z"
      style={st1}
    />
    <path
      id="uuid-26264dfd-7edf-44fa-b3ab-e632ccb10627"
      d="M39.7 31.5h76a2 2 0 0 1 2 2v58.9a2 2 0 0 1-2 2h-76a2 2 0 0 1-2-2V33.5c0-1.1.9-2 2-2z"
      style={st1}
    />
    <path
      d="M84.2 74.9c0-.6-.4-1-1-1H55.6c-.5 0-1 .4-1 1s.5 1 1 1h27.6c.5 0 1-.5 1-1zM98.3 73.9h-10c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1zM104.6 67.6H87c-.6 0-1 .4-1 1s.4 1 1 1h17.6c.6 0 1-.4 1-1s-.5-1-1-1zM73.6 67.6c-.6 0-1 .4-1 1s.4 1 1 1h8.8c.6 0 1-.4 1-1s-.4-1-1-1h-8.8zM70 68.6c0-.6-.4-1-1-1H51.5c-.5 0-1 .4-1 1s.5 1 1 1H69c.6 0 1-.5 1-1zM64 63.3h30.1a1 1 0 0 0 0-2H64c-.5 0-1 .5-1 1s.4 1 1 1zM94.1 80.2H64c-.5 0-1 .4-1 1s.5 1 1 1h30.1c.6 0 1-.4 1-1s-.5-1-1-1z"
      style={st4}
    />
    <ellipse cx="78" cy="30.5" style={st1} rx="21.1" ry="21" />
    <path
      id="uuid-4fb95eab-e3ae-4d86-8ab4-5a483776846b"
      d="M78 12.5c9.9 0 18 8.1 18 18s-8.1 18-18 18-18-8.1-18-18 8.1-18 18-18z"
      style={st2}
    />
    <path
      d="M72.2 19.5c-.6 4.6 3.2 9.6 4.9 11.5h.7c-1.1-3.7-5-16.5-5.6-11.5zm2.7 5.5s-2.1-2.2-2-4.4c.1-2.3 2.1 4.5 2 4.4.1.1 0 0 0 0z"
      style={st3}
    />
    <path
      id="uuid-b88e7498-24f3-4fa5-ba44-988ed6c37f33"
      d="M84.5 36.5c-.3-.8-.9-1.4-1.6-1.8-.6-.3-1.2-.5-1.8-.3-.3-.9-.9-1.9-2-2.3l-.6 1c1.1.2 1.4 1.4 1.5 1.9a3 3 0 0 0-.7 1.2c-.3 1.6.4 3.3 1.8 4.2.4.2.8.4 1.3.4l.9-.2c1.5-.6 2-2.5 1.2-4.1zm-1.7 3.1-.2.1c-.8.2-1.7-.4-2.2-1.4-.5-1.1-.2-2.3.6-2.7l.3-.1c.8-.1 1.6.5 2 1.5.6 1 .3 2.2-.5 2.6z"
      style={st3}
    />
    <path
      id="uuid-822097f2-1ef9-4069-a8dc-c24216319160"
      class={'result-item-svg-highlight-color'}
      d="M78.7 31c1.7-1.9 5.4-6.9 4.9-11.5-.6-5-4.5 7.8-5.6 11.5h-1c-.3 0-.4.2-.4.7l.1.5c-.9.5-1.5 1.3-1.8 2.2-1.3-.3-2.7.6-3.4 2.1-.7 1.7-.2 3.5 1.1 4.1l.8.2c1.1 0 2.3-.8 2.9-2.2.6-1.3.4-2.8-.4-3.6.1-.5.4-1.6 1.4-1.8l.7.2c.3 0 .5-.1.7-.3l.6-1v-.4c-.1-.5-.3-.7-.6-.7zm4.1-10.4c.1 2.3-2 4.4-2 4.4l-.1.1c.1 0 2-6.8 2.1-4.5zm-7.2 17.6c-.4 1-1.4 1.6-2.2 1.4l-.2-.1c-.8-.4-1.1-1.5-.6-2.7.4-.9 1.2-1.5 1.9-1.5l.4.1c.9.5 1.2 1.7.7 2.8z"
    />
    <circle id="uuid-4ea6bf1b-a452-4ca3-b024-66352de6be39" cx="77.9" cy="32" r=".4" style={st1} />
  </svg>
);

const InspirationResultItemTemplate = (context: ResultItemContext) => (
  <result-item
    type={context.item.type}
    class={context.hidden ? 'hidden' : ''}
    href={context.item.links.page}
    key={context.key}
    onClick={() => context.ref.onSelectItem(context.item, context.position, context.queryID, context.listType)}
    tabindex="0"
  >
    <result-item-image>
      {context.item.images.small ? <img src={context.item.images.small} /> : getPlaceholderImage()}
    </result-item-image>
    <result-item-details>
      {context.item.category !== '' ? (
        <result-item-label
          link={context.item.links.category}
          onClick={(event: MouseEvent) =>
            context.ref.onCategoryClick(event, context.item, context.position, context.listType)
          }
        >
          {context.item.category}
        </result-item-label>
      ) : (
        <result-item-label></result-item-label>
      )}
      <result-item-headline>{context.item.name}</result-item-headline>
    </result-item-details>
  </result-item>
);

export default InspirationResultItemTemplate;
